module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAD1BMVEUAAAA3bOk5a+g2a+g4bOjjMQmkAAAABHRSTlMA5kxMPVrHOgAAADlJREFUOMtjGKzA0AUDCIMlRDAlHMESLljAUJSgC8C0mxYSCA7tJBBgVAK/hAhmvoEARXQJIYbBCgDCGpbykj47ZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/archive-fill-pre@2x.png
// module id = zouF
// module chunks = 44